import { resetTransformation as resetTransformationDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & { }

export const resetTransformation = ({
    eventEmitter,
}: Props) => {
    resetTransformationDiagram();
    eventEmitter.emit(Event.updateDataTransformation);
};
